import type { Patient } from "@src/packages/patients/patients.types";
import { isCurrentPartnerParticipation } from "@src/packages/experience";
import type { CycleType } from "./hooks/useCycles";

/** Cycle types that represent a shared treatment rather than a solo journey. */
const SHARED_CYCLE_TYPES: ReadonlySet<string> = new Set([
  "ivf",
  "icsi",
  "iui",
  "fet",
  "embryo_freezing",
]);

/**
 * The partner Care boundary is the server-resolved relationship, not sex at
 * birth or the presence of a legacy partner ID. `partnerConnected` confirms
 * that the relationship is active from the viewer's perspective.
 */
export function isCurrentPartnerCareViewer(
  patient: Patient | null | undefined,
): boolean {
  return Boolean(
    patient?.partnerId &&
    patient.partnerConnected === true &&
    isCurrentPartnerParticipation(
      patient.participantRole,
      patient.participantStatus,
    ),
  );
}

export function isSharedCycleType(
  cycleType: CycleType | string | null | undefined,
): cycleType is CycleType {
  return (
    cycleType !== null &&
    cycleType !== undefined &&
    SHARED_CYCLE_TYPES.has(cycleType)
  );
}

export function shouldUsePartnerCyclePerspective(args: {
  patient: Patient | null | undefined;
  cycleType: CycleType | string | null | undefined;
}): boolean {
  return (
    isCurrentPartnerCareViewer(args.patient) &&
    isSharedCycleType(args.cycleType)
  );
}
